import { render, staticRenderFns } from "./AttachmentField.vue?vue&type=template&id=fa0f5978&scoped=true&"
import script from "./AttachmentField.vue?vue&type=script&lang=js&"
export * from "./AttachmentField.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentField.vue?vue&type=style&index=0&id=fa0f5978&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0f5978",
  null
  
)

export default component.exports